module.exports = __webpack_public_path__ + "img/9788980403158.a2767984.jpg";